import type { EMessageChannel } from 'src/services/api';

const basePath = '/landlord/inner/messages/from-lead';

export const getConversationPath = (channel?: EMessageChannel, leadUuid?: string, backPath?: string, showNavigation: boolean = true) => {
    if (!leadUuid) {
        return;
    }

    let path = `${basePath}?lead_uuid=${leadUuid}`;
    if (channel) {
        path += `&channel=${channel}`;
    }
    if (showNavigation) {
        path += '&show_navigation=true';
    }
    if (backPath) {
        path += `&back_path=${encodeURIComponent(backPath)}`;
    }
    return path;
};
